{
  "article.backHeader.label": "Tillbaka",
  "common.appName": "Oma+",
  "common.brandFullName": "YTK Työelämä",
  "common.loading": "Laddar…",
  "common.notFound.body": "Sidan du söker finns inte eller har tagits bort.",
  "common.notFound.heading": "Sidan hittades inte.",
  "content.unavailable.backHome": "Tillbaka till startsidan",
  "content.unavailable.body": "Innehållstjänsten är tillfälligt otillgänglig. Försök igen senare eller återgå till startsidan.",
  "content.unavailable.heading": "Innehållet är inte tillgängligt just nu.",
  "content.hero.videoLabel": "Video",
  "routes.lakiruutu.title": "Lakiruutu",
  "routes.lakiruutu.empty": "Inga videor tillgängliga.",
  "routes.lakiruutu.showMore": "Visa mer information",
  "routes.lakiruutu.playNewTab": "Spela upp video (öppnas i en ny flik)"
}
